import { render, staticRenderFns } from "./header-button.vue?vue&type=template&id=2b678338&scoped=true&"
import script from "./header-button.vue?vue&type=script&lang=js&"
export * from "./header-button.vue?vue&type=script&lang=js&"
import style0 from "./header-button.vue?vue&type=style&index=0&id=2b678338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b678338",
  null
  
)

export default component.exports